module.exports = __webpack_public_path__ + "img/button-play-store.eb328107.svg";